<template>
  <div class="view admin users">
    <div class="page">
      <div class="header">
        <h2>All Users Management</h2>
      </div>
      <div class="content">
        <div class="card">
          <div class="card-header card-header-flex">
            <div class="d-flex flex-column justify-content-center mr-auto">
              <h5 class="mb-0">Users List</h5>
            </div>
            <div class="d-flex flex-column justify-content-center">
              <div class="">
                <a-button type="default" icon="sync" class="mr-2" @click="$store.dispatch('users/fetchUsers')">
                  Refresh
                </a-button>
                <a-button type="primary" icon="user" @click="$store.dispatch('users/openModal', 'create')">
                  New User
                </a-button>
              </div>
            </div>
          </div>
          <!-- table -->
          <a-table
            :loading="$store.getters['users/loading']"
            :columns="columns"
            :dataSource="users"
            :rowKey="(user, index) => user._id"
            :customRow="rowClick"
            :scroll="{ x: 1200 }"
            :pagination="pagination"
            @change="change"
          >
            <span slot="avatar" slot-scope="user">
              <a-avatar shape="square" :size="28" :src="user.avatar" icon="user" />
            </span>

            <span slot="active" slot-scope="user">
              <span class="dot" :class="{ active: user.active }"></span>
            </span>

            <span slot="contractor" slot-scope="contractor">
              {{ contractor.name }}
            </span>

            <span slot="department" slot-scope="department">
              {{ department | DEPARTMENT_ }}
            </span>

            <span slot="job_title" slot-scope="job_title">
              {{ job_title | JOB_TITLE_ }}
            </span>

            <span slot="created_at" slot-scope="created_at">
              {{ created_at | moment('l') }}
            </span>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import router from '@/router'

export default {
  async beforeRouteEnter(to, from, next) {
    store.dispatch('users/init')
    await store.dispatch('users/fetchUsers')
    next()
  },
  data() {
    return {
      columns: [
        {
          title: 'Avatar',
          key: 'avatar',
          width: '80px',
          fixed: 'left',
          scopedSlots: { customRender: 'avatar' },
        },
        {
          title: 'Username',
          dataIndex: 'username',
          key: 'username',
          width: '120px',
          fixed: 'left',
          sorter: (a, b) => {
            return a.username.localeCompare(b.username)
          },
        },
        {
          title: 'Status',
          key: 'active',
          width: '90px',
          scopedSlots: { customRender: 'active' },
        },
        {
          title: 'Display Name',
          dataIndex: 'display_name',
          key: 'display_name',
          sorter: (a, b) => {
            return a.display_name.localeCompare(b.display_name)
          },
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
          width: 180,
          ellipsis: true,
          sorter: (a, b) => {
            return a.email.localeCompare(b.email)
          },
        },
        {
          title: 'Phone',
          dataIndex: 'phone',
          key: 'phone',
        },
        {
          title: 'Contractor',
          dataIndex: 'contractor',
          key: 'contractor',
          scopedSlots: { customRender: 'contractor' },
        },
        {
          title: 'Department',
          dataIndex: 'department',
          key: 'department',
          scopedSlots: { customRender: 'department' },
        },
        {
          title: 'Job Title',
          dataIndex: 'job_title',
          key: 'job_title',
          scopedSlots: { customRender: 'job_title' },
        },
        {
          title: 'Creation',
          dataIndex: 'created_at',
          key: 'created_at',
          scopedSlots: { customRender: 'created_at' },
        },
      ],
    }
  },
  methods: {
    rowClick: (record) => ({
      on: {
        click: (e) => router.push({ name: 'admin-user', params: { id: record._id } }),
      },
    }),
    change: (pagination, filters, sorter) => {
      store.dispatch('users/setQuery', { pagination, filters, sorter })
    },
  },
  computed: {
    users: () => store.getters['users/users'],
    pagination: () => store.getters['users/pagination'],
  },
  mounted() {
    // console.log(store)
  },
}
</script>

<style lang="scss" scoped>
.admin.users {
  .dot {
    display: inline-block;
    height: 0.86rem;
    width: 0.86rem;
    background: #ff0000;
    border-radius: 20px;
    margin-left: 0.53rem;
    vertical-align: middle;
    position: relative;
    top: -2px;

    &.active {
      background: #00b44b;
    }
  }
}
</style>
